import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/chat/agents/id/runs/runId/page';

export const Route = createFileRoute('/_app/_chat/agents/$id/runs/$runId/')({
  component: Page,
});
